import {
  ApplicationRoutesNgService,
  Route,
} from '../../core/routeGuard/applicationRoutesNg.service';
class NavController {
  static bindings = {
    featureList: '<',
    partnerName: '<',
    rfpId: '<',
    purchasePlanId: '<',
    showPartnerLevelNav: '<', // PPI-1735 - Remove this when the flag goes away. 
    memberId: '<',
    activePage: '@',
    filters: '=',
  };

  partnerName;
  rfpId;
  purchasePlanId;
  isGroupCommitmentPartnerView;
  memberId;
  activePage;
  filters;
  featureList;

  constructor(
    public $scope,
    public $rootScope,
    private applicationRoutesNgService: ApplicationRoutesNgService,
  ) {
    'ngInject';
  }

  getParticipantsImpactMemberUrl(): string {
    return `/aptitude/static/platform/purchase-planning/${this.rfpId}/buyer-member/${this.memberId}/impact`


  }

  get detailsDownloadUrl() {
    return `/aptitude/buyer/PurchasePlanServiceController/download?requestId=${this.rfpId}&purchasePlanId=${this.purchasePlanId}`;
  }

  get detailsUrl() {
    return `/aptitude/static/planning.html#/ppDetails/${this.rfpId}/member/${this.memberId}`;
  }
}

export const MemberNavComponent = {
  controller: NavController,
  bindings: NavController.bindings,
  template: `
    <aptitude-nav>
      <gutter/>
      <nav-item data-test-selector="purchase-plan-details" ng-if="$ctrl.showPartnerLevelNav" url="$ctrl.detailsUrl" active="$ctrl.activePage === 'details'" >
          {{'Purchase Planning'}}
        </nav-item>
        <nav-item data-test-selector="offer-impact" ng-if="$ctrl.showPartnerLevelNav" url="$ctrl.getParticipantsImpactMemberUrl()" active="$ctrl.activePage === 'impact'" >
         {{'Impact'}}
        </nav-item>
      <div ng-class="{'viewingMemberWithMenu': $ctrl.showPartnerLevelNav, 'viewingMember' : !$ctrl.showPartnerLevelNav}">{{ $ctrl.partnerName }} Partner View</div>
      <nav-download 
        url="$ctrl.detailsDownloadUrl" 
        data-test-selector="details-download" 
        text="linkText"
        filters="$ctrl.filters"  
        is-new-download="true"
        plan-id="$ctrl.purchasePlanId" 
        rfp-id="$ctrl.rfpId" 
        file-name="'PurchasePlan_' + $ctrl.rfpId + '.xlsx'"
        ></nav-download>
      <gutter/>
    </aptitude-nav>
      `,
};
